module.exports = __webpack_public_path__ + "img/20190529114836微信截图_20190529115232.png.01068258.png";